import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-carrier-viewer',
  templateUrl: './carrier-viewer.component.html',
  styleUrls: ['./carrier-viewer.component.css']
})
export class CarrierViewerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
